import { useQuery } from "react-query";
import api from "../api";

export const useGetWithdrawRequestForUser = (status) => {
  return useQuery(["withdraw_request", status], () => {
    const url = status === "ALL" ? "/withdraw" : `/withdraw?status=${status}`;
    return api.get(url).then((res) => res.data);
  });
};
